module.exports = __webpack_public_path__ + "static/36-arguments-for-the-existence-of-god-6e908a7860795365cca22cf08156fe24.jpg";